import { type ReactNode } from 'react';
import { InboxIcon } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface EmptyStateProps {
  heading: string;
  children?: ReactNode;
  action?: {
    content: string;
    onAction: () => void;
  };
  icon?: React.ReactNode;
}

export function EmptyState({ heading, children, action, icon }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4 text-center">
      <div className="h-12 w-12 rounded-full bg-muted flex items-center justify-center mb-4">
        {icon || <InboxIcon className="h-6 w-6 text-muted-foreground" />}
      </div>
      <h3 className="text-lg font-semibold mb-2">{heading}</h3>
      {children && (
        <div className="text-sm text-muted-foreground max-w-sm mb-4">
          {children}
        </div>
      )}
      {action && (
        <Button onClick={action.onAction}>
          {action.content}
        </Button>
      )}
    </div>
  );
}
